import FooterControl from '@/components/FooterControl.vue';
import Md5 from 'md5';

export default {
  name: 'sale-drug',
  components: { FooterControl },
  // prop:['address'],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPassword !== '') {
          this.$refs.ruleForm.validateField('checkPassword');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      const values = this.ruleForm.checkPassword;
      if (values === '') {
        callback(new Error('请再次输入密码'));
      } else if (values !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPassword: '',
        password: '',
        checkPassword: '',
      },
      rules: { // 表单校验规则
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
        ],
      },
    };
  },

  methods: {
    goback() {
      this.$router.go(-1);
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newForm = {
            oldPassword: Md5(this.ruleForm.oldPassword),
            newPassword: Md5(this.ruleForm.password),
          };
          this.$api.global.updatePassword({
            ...newForm,
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '修改密码成功！',
            });
            setTimeout(() => {
              this.goback();
            }, 1000);
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
  },
  computed: {
  },
};
